export default __webpack_public_path__ + "static/media/rights-icon.34ed1377.png";